import { useTranslation } from "react-i18next";
import * as APITypes from "~/API";
import { InternalTypographyLink } from "../InternalLink";
import {
  financeInventoryHref,
  financeInventoryKindLabel,
} from "~/utils/finance/inventoryHref";

export type FinanceInventoryLinkProps = {
  entityType?: APITypes.EntityType;
  entityID?: string;
  name?: string | null;
};

export function FinanceInventoryLink({
  entityType,
  entityID,
  name,
}: FinanceInventoryLinkProps) {
  const { t } = useTranslation();
  const displayName = name || entityID;
  if (!entityID) {
    return <>{displayName || t("Unavailable")}</>;
  }
  const kind = financeInventoryKindLabel(entityType, t);
  return (
    <InternalTypographyLink to={financeInventoryHref(entityType, entityID)}>
      {`${kind}: ${displayName}`}
    </InternalTypographyLink>
  );
}
